import { styled } from '@mui/system'
import { Grid } from '@mui/material'
import Typography from '../../../atoms/typography'

const Root = styled('div')`
	position: relative;
	padding: 60px ${({ theme }) => theme.spacing(3)} 0;
	${({ theme }) => theme.breakpoints.up('sm')} {
		padding: 80px ${({ theme }) => theme.spacing(5)} 0;
	}
`

const GridContainer = styled(Grid)`
	display: grid;
	grid-template-columns: 1fr;
	gap: ${({ theme }) => theme.spacing(2)};
	${({ theme }) => theme.breakpoints.up('sm')} {
		grid-template-columns: 1fr 1fr;
	}
`

const GridBorder = styled(Grid)`
	border: 1px solid ${({ theme }) => theme.palette.grey.light};
	padding: ${({ theme }) => theme.spacing(4)};
`

const Title = styled(Typography)`
	margin-bottom: ${({ theme }) => theme.spacing(3)};
	::first-letter {
		text-transform: capitalize;
	}
`
const Description = styled(Typography)``

export { Root, GridContainer, GridBorder, Title, Description }
